module.exports = __webpack_public_path__ + "static/media/audio-17-tt.93b10de7.mp3";